const SEO_REL_BLOCK = new Set(['nofollow', 'sponsored', 'ugc']);

function siteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin).replace(/\/$/, '');
  }
  return (process.env.REACT_APP_SITE_URL || '').replace(/\/$/, '');
}

/**
 * Removes rel values that block crawlers on internal anchors only (Maison parity).
 */
export function stripSeoRelFromInternalAnchors(html, siteBaseUrl) {
  if (typeof document === 'undefined' || !html || typeof html !== 'string') return html;
  const base = (siteBaseUrl || siteOrigin() || '').replace(/\/$/, '');
  const div = document.createElement('div');
  div.innerHTML = html;

  div.querySelectorAll('a[href]').forEach((a) => {
    const href = (a.getAttribute('href') || '').trim();
    if (!href) return;

    let internal = false;
    if (href.startsWith('/') || href.startsWith('#') || href.startsWith('?')) {
      internal = true;
    } else if (base && (href === base || href.startsWith(`${base}/`))) {
      internal = true;
    } else if (!/^[a-z][a-z0-9+.-]*:/i.test(href)) {
      internal = true;
    }

    if (!internal) return;

    const rel = a.getAttribute('rel');
    if (!rel) return;

    const parts = rel
      .split(/\s+/)
      .map((p) => p.trim())
      .filter((p) => p && !SEO_REL_BLOCK.has(p.toLowerCase()));

    if (parts.length) a.setAttribute('rel', parts.join(' '));
    else a.removeAttribute('rel');
  });

  return div.innerHTML;
}
